<template>
  <div>
    <div id="task-panel-mask"></div>
    <div id="task-panel">
      <h2 class="title">
        出行设置
        <button class="close-btn" @click="closeTaskPanel">×</button>
      </h2>
      <h3>任务类型</h3>
      <div class="type">
        <button
          :class="taskType === 0 && 'active'"
          @click="changeTask('type', 0)"
        >
          <i></i>
          自定义路段
        </button>
        <button
          :class="taskType === 1 && 'active'"
          @click="changeTask('type', 1)"
        >
          <i></i>
          顺路派送
        </button>
        <button
          :class="taskType === 2 && 'active'"
          @click="changeTask('type', 2)"
        >
          <i></i>
          回路派送
        </button>
        <button
          :class="taskType === 3 && 'active'"
          @click="changeTask('type', 3)"
        >
          <i></i>
          广播型派送
        </button>
      </div>
      <h3>交通方式</h3>
      <div class="type">
        <button id='tool0'
          :class="taskTool === 0 && 'active'"
          @click="changetool('bicycle', 0)"
        >
          <i></i>
          步行
        </button>
        <button id='tool1'
          :class="taskTool === 1 && 'active'"
          @click="changetool('bicycle', 1)"
        >
          <i></i>
          自行车/电动车
        </button>
        <button id='tool2'
          :class="taskTool === 2 && 'active'"
          @click="changetool('car', 2)"
        >
          <i></i>
          驾车
        </button>
        <button id='tool3'
          :class="taskTool === 3 && 'active'"
          @click="changetool('car', 3)"
        >
          <i></i>
          小型货车
        </button>
      </div>
      <h3>交通方案</h3>
      <div class="type">
        <button id='plan0'
          :class="scheme === 0 && 'active'"
          @click="changePlan('car', 0)"
        >
          <i></i>
          时间最少
        </button>
        <button id='plan1'
          :class="scheme === 1 && 'active'"
          @click="changePlan('bicycle', 1)"
        >
          <i></i>
          最短距离
        </button>
        <button id='plan2'
          :class="taskTool === 2 && 'active'"
          @click="changePlan('bicycle', 2)"
        >
          <i></i>
          避开高速
        </button>
      </div>
      <button class="save-btn" @click="closeTaskPanel">选择</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
import VueCookies from 'vue-cookies';//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
Vue.use(VueCookies);//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码代码新加代码新加代码
export default {
  name: "TaskPanel",
  props: ["onClose", "onSave"],
  data() {
    return {
      scheme: 0,
    };
  },
  computed: {
    taskType() {
      return this.$store.state.taskType;
    },
    taskTool() {
      return this.$store.state.taskTool;
    },
  },
  methods: {
    closeTaskPanel() 
    {
      this.onClose();
    },
    changeTask(key, point) 
    {
      this.$cookies.set("jiaotongtool", "car");//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
      this.$store.dispatch("changeTask", [key, point]);
      this.onSave();
    },
    changetool(key, point) //新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
    {
      this.$cookies.set("jiaotongtool", key);//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码   
      if(point==0)
      {
        document.getElementById("tool0").className="active";
        document.getElementById("tool1").className="";
        document.getElementById("tool2").className="";
        document.getElementById("tool3").className="";
        
      }    
      if(point==1)
      {
        document.getElementById("tool1").className="active";
        document.getElementById("tool0").className="";
        document.getElementById("tool2").className="";
        document.getElementById("tool3").className="";
      }   
      if(point==2)
      {
        document.getElementById("tool2").className="active";
        document.getElementById("tool1").className="";
        document.getElementById("tool0").className="";
        document.getElementById("tool3").className="";
      }   
      if(point==3)
      {
        document.getElementById("tool2").className="";
        document.getElementById("tool1").className="";
        document.getElementById("tool0").className="";
        document.getElementById("tool3").className="active";
      } 
    },
    changePlan(key, point) //新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
    {
      this.$cookies.set("jiaotongtool", key);//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码 
      if(point==0)
      {
        document.getElementById("plan0").className="active";
        document.getElementById("plan1").className="";
        document.getElementById("plan2").className="";
      }    
      if(point==1)
      {
        document.getElementById("plan1").className="active";
        document.getElementById("plan0").className="";
        document.getElementById("plan2").className="";
      }   
      if(point==2)
      {
        document.getElementById("plan2").className="active";
        document.getElementById("plan1").className="";
        document.getElementById("plan0").className="";
      } 
    },
  },
};
</script>


<style lang="less" scoped>
@import "../assets/less/TaskPanel.less";
</style>